import { Action } from '@ngrx/store';

export const enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  LOGOUT = '[Auth] Logout',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_ERROR = '[Auth] Login Error',
  LOGIN_REDIRECT = '[Auth] Login Redirect',
}

interface Login extends Action {
  type: AuthActionTypes.LOGIN;
  payload: any;
}

interface Logout extends Action {
  type: AuthActionTypes.LOGOUT;
  payload: any;
}

interface LoginSuccess extends Action {
  type: AuthActionTypes.LOGIN_SUCCESS;
  payload: any;
}

interface LoginError extends Action {
  type: AuthActionTypes.LOGIN_ERROR;
  payload: any;
}

interface LoginRedirect extends Action {
  type: AuthActionTypes.LOGIN_REDIRECT;
  payload: any;
}

export type AuthActions =
  | Login
  | Logout
  | LoginSuccess
  | LoginError
  | LoginRedirect;
